import { userService } from '../service/UserService';
import { router } from '../router';
import axios from 'axios';

const user = JSON.parse(localStorage.getItem('user'));

const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ dispatch, commit }, { username, password }) {
            commit('loginRequest', { username });

            userService.login(username, password)
                .then(
                    user => {
                        commit('loginSuccess', user);
                        router.push('/');
                    },
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        logout({ commit }) {
            userService.logout();
            commit('logout');
            router.push('/login');
        }
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;

            axios.defaults.headers.common['Authorization'] =  'Bearer ' + user.token ;
            axios.defaults.headers.common['content-Type'] = "application/json;charset=utf-8";
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;

            axios.defaults.headers.common['Authorization'] =  'Bearer None';
            axios.defaults.headers.common['content-Type'] = "application/json;charset=utf-8";
        },
        logout(state) {
            state.status = {};
            state.user = null;
        }
    }
}